var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.55156 16.5C2.21641 16.5 1.92949 16.3694 1.69082 16.1083C1.45215 15.8472 1.33281 15.5333 1.33281 15.1667V2.5H0.5V1.16667H4.31875V0.5H9.68125V1.16667H13.5V2.5H12.6672V15.1667C12.6672 15.5222 12.5453 15.8333 12.3016 16.1C12.0578 16.3667 11.7734 16.5 11.4484 16.5H2.55156ZM11.4484 2.5H2.55156V15.1667H11.4484V2.5ZM4.70469 13.2556H5.92344V4.38889H4.70469V13.2556ZM8.07656 13.2556H9.29531V4.38889H8.07656V13.2556Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBin);
export default __webpack_public_path__ + "static/media/icon-bin.c10095abbc3ed3cef943bb12da30ce53.svg";
export { ForwardRef as ReactComponent };